const stateKeys = ['current-installation']

export const state = () => ({
  hasRegisteredNewInstallation: false
})

export const mutations = {
  setHasRegisteredNewInstallation(state, value) {
    state.hasRegisteredNewInstallation = value
  }
}

export const actions = {
  clearStorage({ dispatch }) {
    dispatch('maintenance/clearStorage', null, {
      root: true
    })

    for (let i = 0; i < stateKeys.length; i++) {
      this.$storage.removeUniversal(stateKeys[i])
    }
  },
  getCurrent() {
    return this.$storage.getUniversal('current-installation')
  },
  setCurrent({ dispatch }, installation) {
    this.$storage.setUniversal('current-installation', installation)
    dispatch('maintenance/setByInstallation', installation, {
      root: true
    })
  },
  clearCurrent() {
    this.$storage.removeUniversal('current-installation')
  },
  async confirmConsentPreference(_, { consentId, installationId, status }) {
    return await this.$marlonApi.confirmConsentPreference(
      consentId,
      installationId,
      status
    )
  },
  generateInstallationIdentifier(_, units) {
    const priorityOrder = ['indoor', 'outdoor', 'lan_adapter', 'tank']

    const unit = priorityOrder
      .map((type) => units.find((unit) => unit.type === type))
      .find(Boolean)

    return unit ? `${unit.material}-${unit.serial}` : ''
  }
}
